import React from 'react';
import { useTranslation } from 'react-i18next';
import AdoptableButton from '@wix/da-ds/pkg/Buttons/AdoptableButton';
import { formatDollarsWithOptionalCents } from '../../../../../../utils/formatting';
import { useBuyNowAction, useMakeOfferAction, useManageOfferAction } from '../../hooks';
const BuyerButtons = ({ deviation, adoptableState: { canBuyNow, canMakeNewOffer, canManageExistingOffer, fixedPrice } })=>{
    const { t } = useTranslation();
    const sectionname = 'side-rail';
    const [onMakeOffer, makeOfferBiData] = useMakeOfferAction(deviation, {
        sectionname
    });
    const [onManageOffer, manageOfferBiData] = useManageOfferAction(deviation, {
        sectionname
    });
    const [onBuyNow] = useBuyNowAction(deviation, {
        sectionname,
        purchase_price: fixedPrice
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, canBuyNow && /*#__PURE__*/ React.createElement(AdoptableButton, {
        key: "buy-now",
        priority: "secondary",
        onClick: onBuyNow
    }, t('sidebar.exclusives.buttons.buyer.buyNow', {
        price: formatDollarsWithOptionalCents(fixedPrice)
    })), canMakeNewOffer && /*#__PURE__*/ React.createElement(AdoptableButton, {
        key: "make-offer",
        priority: "primary",
        onClick: onMakeOffer,
        biData: makeOfferBiData
    }, t('sidebar.exclusives.buttons.buyer.makeOffer')), canManageExistingOffer && /*#__PURE__*/ React.createElement(AdoptableButton, {
        key: "manage-offer",
        priority: "primary",
        onClick: onManageOffer,
        biData: manageOfferBiData
    }, t('sidebar.exclusives.buttons.buyer.manageOffer')));
};
BuyerButtons.displayName = 'BuyerButtons';
export default BuyerButtons;
